// Description: This file contains the notification function
const notification = (el, cookieName, delay) => {
	// check if cookie.setup is set and if notification cookie is set in localstorage

	if (
		document.cookie.indexOf('cookies.setup') === -1 ||
		localStorage.getItem(cookieName) !== null
	) {
		return;
	}

	// get notification element
	const notification = document.querySelector(el);

	//show notification after delay
	setTimeout(() => {
		notification.showModal();
	}, delay);

	// set cookie in localstorage when notification is closed
	notification.addEventListener('close', () => {
		localStorage.setItem(cookieName, 'true');
	});
};

export default notification;
